var styles = {"icon":"styles_icon__KxSjo","labelContainer":"styles_label-container__jRapo","label":"styles_label__EeNMK","ellipsis":"styles_ellipsis__32iYb"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
